const COMMON_PPREFIX = "store/authReducer";

export const SET_PROCESSING = `${COMMON_PPREFIX}/SET_PROCESSING`;
export const CURRENT_USER = `${COMMON_PPREFIX}/CURRENT_USER`;
export const CURRENT_TOKEN = `${COMMON_PPREFIX}/CURRENT_TOKEN`;
export const AUTH_STATUS = `${COMMON_PPREFIX}/AUTH_STATUS`;